import {Injectable} from "@angular/core";
import {SUPPORTED_LANGUAGES, languageSelectionOptions} from "./languages";
import {LanguageDefinition} from "./language-definition";
import {SelectOption} from "./select/select.component";

@Injectable()
export class SupportedLanguagesProvider {

  getLanguages(): LanguageDefinition[] {
    return SUPPORTED_LANGUAGES;
  }

  getSelectionOptions(): SelectOption[] {
    return languageSelectionOptions();
  }
}
